import hoistNonReactStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import getGqlOperationName from '../../../../utils/getGqlOperationName';

const dynamicTreeSearchBodyMapper = Component => {
  const Hoc = props => {
    const { gqlQuery, gqlVariables, gqlSkip, formatAfterGqlQuery } = props;

    const dataPropertyName = useMemo(() => getGqlOperationName(gqlQuery), [
      gqlQuery,
    ]);

    const { data, loading, error } = useQuery(gqlQuery, {
      variables: gqlVariables,
      skip: gqlSkip,
    });

    const items = useMemo(() => {
      if (!data) {
        return [];
      }
      const rawItems = data[dataPropertyName];
      return rawItems && formatAfterGqlQuery
        ? formatAfterGqlQuery(rawItems)
        : rawItems;
    }, [data, dataPropertyName, formatAfterGqlQuery]);

    return (
      <Component {...props} error={error} items={items} loading={loading} />
    );
  };

  Hoc.displayName = `dynamicTreeSearchBodyMapper(${
    Component.displayName || Component.name
  })`;

  Hoc.propTypes = {
    gqlQuery: PropTypes.object.isRequired,
    gqlVariables: PropTypes.object.isRequired,
    gqlSkip: PropTypes.bool,
    formatAfterGqlQuery: PropTypes.func,

    searchQuery: PropTypes.string.isRequired,
    treeAdapter: PropTypes.object.isRequired,
    treePlugins: PropTypes.array.isRequired,
    treeContext: PropTypes.any,
    rootModels: PropTypes.array,
    isSyntheticRootNodeAlwaysVisible: PropTypes.bool,
  };

  Hoc.defaultProps = {
    rootModels: null,
    treeContext: null,
    formatAfterGqlQuery: null,
    isSyntheticRootNodeAlwaysVisible: false,
    gqlSkip: false,
  };

  return hoistNonReactStatics(Hoc, Component);
};

export default dynamicTreeSearchBodyMapper;
